import React, { useState } from 'react';
import PropTypes from 'prop-types';

function SectionIcon({ children }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {children}
    </svg>
  );
}

SectionIcon.propTypes = {
  children: PropTypes.node.isRequired,
};

const ICONS = {
  basic: (
    <SectionIcon>
      <circle cx="12" cy="12" r="10" />
      <path d="M12 16v-4" />
      <path d="M12 8h.01" />
    </SectionIcon>
  ),
  times: (
    <SectionIcon>
      <path d="M16 14v2.2l1.6 1" />
      <path d="M16 2v4" />
      <path d="M21 7.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h3.5" />
      <path d="M3 10h5" />
      <path d="M8 2v4" />
      <circle cx="16" cy="16" r="6" />
    </SectionIcon>
  ),
  project: (
    <SectionIcon>
      <path d="M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z" />
      <path d="M8 10v4" />
      <path d="M12 10v2" />
      <path d="M16 10v6" />
    </SectionIcon>
  ),
  assignment: (
    <SectionIcon>
      <path d="M10 15H6a4 4 0 0 0-4 4v2" />
      <path d="m14.305 16.53.923-.382" />
      <path d="m15.228 13.852-.923-.383" />
      <path d="m16.852 12.228-.383-.923" />
      <path d="m16.852 17.772-.383.924" />
      <path d="m19.148 12.228.383-.923" />
      <path d="m19.53 18.696-.382-.924" />
      <path d="m20.772 13.852.924-.383" />
      <path d="m20.772 16.148.924.383" />
      <circle cx="18" cy="15" r="3" />
      <circle cx="9" cy="7" r="4" />
    </SectionIcon>
  ),
  details: (
    <SectionIcon>
      <rect width="8" height="4" x="8" y="2" rx="1" ry="1" />
      <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
      <path d="M12 11h4" />
      <path d="M12 16h4" />
      <path d="M8 11h.01" />
      <path d="M8 16h.01" />
    </SectionIcon>
  ),
};

export default function ScheduleDrawerSection({
  title,
  icon,
  children,
  collapsible = true,
}) {
  const [open, setOpen] = useState(true);
  const isOpen = !collapsible || open;

  return (
    <div className={`schedule-drawer-section${isOpen ? ' is-open' : ' is-closed'}${collapsible ? '' : ' is-static'}`}>
      {collapsible ? (
        <button
          type="button"
          className="schedule-drawer-section-header"
          aria-expanded={open}
          onClick={() => setOpen((current) => !current)}
        >
          <span className="schedule-drawer-section-title">
            <span className="schedule-drawer-section-icon">{ICONS[icon]}</span>
            {title}
          </span>
          <svg
            className="schedule-drawer-section-chevron"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <path d="m6 9 6 6 6-6" />
          </svg>
        </button>
      ) : (
        <div className="schedule-drawer-section-header">
          <span className="schedule-drawer-section-title">
            <span className="schedule-drawer-section-icon">{ICONS[icon]}</span>
            {title}
          </span>
        </div>
      )}
      <div className="schedule-drawer-section-body" hidden={!isOpen}>
        {children}
      </div>
    </div>
  );
}

ScheduleDrawerSection.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.oneOf(['basic', 'times', 'project', 'assignment', 'details']).isRequired,
  children: PropTypes.node.isRequired,
  collapsible: PropTypes.bool,
};

ScheduleDrawerSection.defaultProps = {
  collapsible: true,
};
